module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_newyearscard-18d9915ed4f316bf301d5df3767a3cbc.jpg";